import clsx from 'clsx';
import * as styles from './flex-mark.css';

/**
 * - `caution`: the colours of a caution banner.
 * - `solid`: on a solid button, where the body takes the button's text colour.
 * - `mono`: one colour, the text colour, for warning and critical controls.
 */
type FlexMarkTone = 'caution' | 'solid' | 'mono';
type FlexMarkSize = keyof typeof styles.markSize;

type FlexMarkProps = { tone?: FlexMarkTone; size?: FlexMarkSize };

/** Pluma Icons has no Flex mark, and its icons are single-colour. */
export function FlexMark({ tone, size = 'sm' }: FlexMarkProps) {
  return (
    <svg
      className={clsx(styles.mark, styles.markSize[size], tone == null ? undefined : styles[tone])}
      viewBox="0 0 160 160"
      aria-hidden="true"
      focusable="false"
      data-testid="flex-mark"
    >
      <path
        className={styles.body}
        d="M0 40H20A20 20 0 0 0 40 20A20 20 0 0 1 60 0H160V20A20 20 0 0 1 140 40H60A20 20 0 0 0 40 60A20 20 0 0 1 20 80H0Z"
      />
      <path
        className={styles.accent}
        d="M0 120H20A20 20 0 0 0 40 100A20 20 0 0 1 60 80H120V100A20 20 0 0 1 100 120H60A20 20 0 0 0 40 140A20 20 0 0 1 20 160H0Z"
      />
    </svg>
  );
}
